import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Slider from "../components/Slider"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class Blog extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)

    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    this.coords = {
      x: 0,
      y: 0,
    }

    this.cta = qsa(".title-wrapper h2", this.el)

    this.mouse = qs(".mouse-icon", this.el)
    this.inner = qs(".blog-inner", this.el)
    this.referenceItem = qs(".desktop .blog-item", this.el)
    this.mouseRadius = 80
    this.activeItem = 0
    this.items = qsa(".desktop .blog-item", this.el)
    this.nbItems = qsa(".desktop .blog-item", this.el).length

    this.onBlog = false

    this.currentCount = qs(".current-count", this.el)
    this.totalCount = qs(".total-count", this.el)

    this.rotation = 0

    this.totalCount.innerHTML = String(this.nbItems).padStart(2, "0")

    this.sliderDOM = qs(".slider", this.el)
    this.slider = new Slider(this.sliderDOM)
  }

  onClick = e => {
    if (this.onBlog === false) return

    if (this.mouse.classList.contains("mouse-icon_active") === false) return

    this.items[this.activeItem].classList.add("blog-item_small")
    this.items[this.activeItem].classList.remove("blog-item_active")

    let x = 0

    if (this.rotation === 0) {
      this.activeItem++
      x = this.referenceItem.offsetWidth + (window.innerWidth * 15) / 100
    }

    if (this.rotation === 180) {
      this.activeItem--
      x = this.referenceItem.offsetWidth + (window.innerWidth * 15) / 100
    }

    this.items[this.activeItem].classList.remove("blog-item_small")
    this.items[this.activeItem].classList.add("blog-item_active")

    gsap.to(this.inner, {
      x: `${-x * this.activeItem}px`,
      duration: 1.2,
    })

    gsap.fromTo(
      qsa(".blog-item_active .line-0"),
      {
        autoAlpha: 0,
        x: 50,
      },
      {
        autoAlpha: 1,
        stagger: 0.1,
        x: 0,
        duration: 1.2,
      }
    )

    this.currentCount.innerHTML = String(this.activeItem + 1).padStart(2, "0")
  }

  onResize = () => {
    this.items[this.activeItem].classList.add("blog-item_small")

    this.activeItem = 0

    this.currentCount.innerHTML = String(this.activeItem + 1).padStart(2, "0")

    this.items[this.activeItem].classList.remove("blog-item_small")

    gsap.to(this.inner, {
      x: `${0}px`,
    })
  }

  tick(obj) {
    const x = this.coords.x
    const y = this.coords.y

    if (this.activeItem === 0) {
      this.rotation = 0
    } else if (this.activeItem === this.nbItems - 1) {
      this.rotation = 180
    } else {
      this.rotation = x < window.innerWidth / 2 ? 180 : 0
    }
    this.mouse.style.transform = `translate(${x - this.mouseRadius / 2}px, ${y - this.mouseRadius / 2}px) rotate(${this.rotation}deg)`
  }

  onMouseMove = e => {
    const rect = this.el.getBoundingClientRect()

    this.coords.x = e.clientX - rect.left
    this.coords.y = e.clientY - rect.top
  }

  on() {
    window.addEventListener("click", this.onClick)
    window.addEventListener("resize", this.onResize)
    window.addEventListener("mousemove", this.onMouseMove)

    this.cta.forEach(cta => {
      cta.addEventListener("mouseenter", () => {
        this.mouse.classList.remove("mouse-icon_active")
      })
      cta.addEventListener("mouseleave", () => {
        this.mouse.classList.add("mouse-icon_active")
      })
    })

    this.el.addEventListener("mouseenter", () => {
      this.onBlog = true
      this.mouse.classList.add("mouse-icon_active")
    })

    this.el.addEventListener("mouseleave", () => {
      this.onBlog = false
      this.mouse.classList.remove("mouse-icon_active")
    })
  }

  animate() {
    const lines = qsa(".blog-item_active .line-0", this.el)
    const img = qsa(".blog-item_active .inner", this.el)
    const smallImg = qs(".blog-item_small .inner", this.el)
    const featuredItem = qs(".featured-item", this.el)
    const blogItems = qsa(".slider-inner .blog-item", this.el).slice(0, 2)

    gsap.from([img, smallImg], {
      width: "0%",
      height: "0%",
      stagger: 0.05,
      duration: 1.2,
      scrollTrigger: {
        trigger: img,
        start: "top bottom",
      },
    })

    gsap.from(lines, {
      y: "100",
      autoAlpha: 0,
      stagger: 0.05,
      duration: 1.2,
      scrollTrigger: {
        trigger: lines,
        start: "top bottom",
      },
    })

    gsap.from(featuredItem, {
      y: "50",
      autoAlpha: 0,
      duration: 1.2,
      scrollTrigger: {
        trigger: featuredItem,
        start: "top bottom",
      },
    })

    gsap.from(blogItems, {
      y: "50",
      autoAlpha: 0,
      stagger: 0.1,
      duration: 1.2,
      scrollTrigger: {
        trigger: blogItems,
        start: "top bottom",
      },
    })
  }
}
